import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p> International Ply </p>
        <p>
        Website under construction
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
         
        </a>
      </header>
    </div>
  );
}

export default App;
